import React, {useContext} from 'react';
import {Button} from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTrash} from '@fortawesome/free-solid-svg-icons';
import {MDBCheckbox} from 'mdb-react-ui-kit';
import NothingToDisplay from '../../NothingToDisplay';
import PhotoList from './PhotoList';
import {Dropdown} from 'react-bootstrap';
import {MadricContext} from '../../../Context/MadricContext';

/**
 * Vue de l'historique d'un chantier
 * @param {*} props props
 * @return {JSX}
 */
function ChantierInfoPhotoView(props) {
  const f = props.filteredArray.filter((r) => r.type === 'photo').slice(0, props.nbItems);

  const {listeEmploye} = useContext(MadricContext);

  return (
    <React.Fragment>
      <Button
        style={{backgroundColor: '#212529', color: 'white', marginBottom: '15px'}}
        onClick={props.addPhoto}>
        Ajouter Photo
      </Button>
      <div className="chantierheure-filter-container">
        <Dropdown >
          <Dropdown.Toggle
            className="chantierheure-form-control"
            style={{
              backgroundColor: 'white',
              marginTop: '0px',
              marginLeft: '0px',
              color: 'black',
              height: '47px',
              border: '2px solid black',
            }}>
            {props.inputRef.label}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {listeEmploye.map((user, index) => {
              return <Dropdown.Item key={index} onClick={() => props.handleChange(user)}>{user.label}</Dropdown.Item>;
            })}
          </Dropdown.Menu>
        </Dropdown>

        <DatePicker
          className="chantierheure-form-control"
          type="date"
          selected={props.dateRef}
          onChange={props.handleDateChange}
          placeholderText="Filtrer par date"
          dateFormat="dd-MM-yyyy" />
        <FontAwesomeIcon
          className="chantierheure-trash-icon"
          icon={faTrash}
          onClick={() => props.removeDate()} />
      </div>
      <div className="chantierheure-filter-container">
        <DatePicker
          className="chantierheure-form-control2"
          type="text"
          selected={props.dateRef}
          onChange={props.handleDateChange}
          placeholderText="Filtrer par date"
          dateFormat="dd-MM-yyyy" />
        <FontAwesomeIcon
          className="chantierheure-trash-icon2"
          icon={faTrash}
          onClick={() => props.removeDate()} />
      </div>

      <div>
        <MDBCheckbox name='extra1' label='Extra possible' inline onChange={props.handleCheckboxChange}/>
        {localStorage.getItem('admin') === '1' ?
        <React.Fragment>
          <MDBCheckbox name='extra2' label='Extra valider' inline onChange={props.handleCheckboxChange} />
          <MDBCheckbox name='extra3' label='Extra confirmer' inline onChange={props.handleCheckboxChange}/>
        </React.Fragment> : '' }
        <MDBCheckbox name='avancement' label='Avancement' inline onChange={props.handleCheckboxChange}/>
      </div>
      {!props.imageOnScreen ?<Button
        style={{backgroundColor: '#212529', color: 'white'}}
        onClick={() => props.getPhotos()}>
        Afficher les photos
      </Button> : ''}
      <div className="photo-grid">
        {f.map((obj, index) => {
          return <PhotoList key={index} photo={obj} openModal={props.openModal} isFacture={false}/>;
        })}
      </div>

      {!props.imageOnScreen ? '' : f.length === 0 ? <NothingToDisplay /> : <Button
        style={{backgroundColor: '#212529', color: 'white'}}
        onClick={props.moreElements}>
        Charger plus d'éléments
      </Button>}
    </React.Fragment>
  );
}

export default ChantierInfoPhotoView;
